import { Link } from "react-router-dom"


const UserDetail = ({form_num,name,father_name}) => {
  return (
    <div className='row align-items-center px-md-4'>
                <div className='col-12 col-md-3'>
                    <h6>From Number</h6>
                    <h5 className=' h6 fw-bold'>{form_num}</h5>
                </div>
                <div className='col-12  col-md-3'>
                    <h6>Student Name</h6>
                    <h5 className='  h6 fw-bold'>{name}</h5>
                </div>
                <div className='col-12  col-md-3'>
                    <h6>Parent Name <span className='text-danger fw-bold fs-5 mb-0'>*</span></h6>
                    {father_name !== null ? 
                    <h5  className='h6 fw-bold'>{father_name}</h5>
                    :
                    <Link to="/student/dashboard" className='d-inline-block btn ms-auto btn-sm  btn-warning'>Go to family detail section</Link>
                    }
                </div>

            </div>
  )
}

export default UserDetail